
    
  import React, { useReducer } from "react";
  import axios2 from 'services/axios2';

  import {useParams} from "react-router-dom";
  import {Link,hashHistory} from 'react-router-dom';
  import { ToastContainer, toast } from 'react-toastify';
  import NuDropdown from "components/nubox/NuDropdown";

  import FileUpload from "components/nubox/FileUpload";
  import NuConfirm from "components/nubox/Box/NuConfirm";
  import NuInput from "components/nubox/NuInput";
  import ListFile from "components/ListFile";
  import NuFileUploadModal from "components/nubox/Box/NuFileUploadModal"
  import NuLoading from 'components/nubox/NuLoading';

  import List from "components/nubox/list/List";
  import ListItemButton from "components/nubox/list/ListItemButton";
  import ListItemText  from "components/nubox/list/ListItemText";
  import ListItemIcon from "components/nubox/list/ListItemIcon";
  import ListSubheader from "components/nubox/list/ListSubheader";
   

  import { withRouterJim } from "router/withRouterJim";
  import ImageUploadSingle from 'components/nubox/ImageUploadSingle';
  import moment from "moment";

  import { NotificationContainer, NotificationManager } from 'react-notifications';
  import {
    Table,
    Button,
    Container,
    Modal,
    ModalHeader,
    ModalBody,
    FormGroup,
    ModalFooter,
    ToastHeader,
  } from "reactstrap";


  const cbo=[
    {  value:'1', label: 'label1'},
  ]
  
  let initialForm = {
    idd:0,
    ope:'n',  
    id_exa:0,
    
    
    titulo:'',
    descrip:'',
    filename:'',
    fecha_ini:'',
    hora_ini:'',
    fecha_fin:'',
    hora_fin:'',
    duracion:0,

    permiteverexa_sn:0,
    nro_preg:0,
    nro_pregxpag:0,
    nro_intentos:0,
    nota_aprob:0,
    nota_max:0,
    id_califcate:0,
    id_tipocalif:0,
    id_pregcate	:0,

    id_mate:0,
    id_peri:0,
    id_tema:0,
    id_estadoex:1,
  };

  //$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$
  class Examend extends React.Component {
    state = {
      isloaging:false,
      modalShow: false,
      modalImagen: false,
      
      form: Object.assign({}, initialForm),
      tarea_file:[],
      tarea_file_sel:{}, /* objeto seleccionado*/
      data: [],/* lista  */
      options: [
        { value:0, nombre:'midocuemnto.doc', filename: 'hh4488884.doc'},
        { value:1, nombre:'archivo.jpg', filename:'jjj33444.jpg'},
        { value:2, nombre:'archivo3.png', filename:'66s666s6s.png'},
      ],
      optionSelected:{}, 
      
      
    };
     //--------------------------------------
    constructor(props) {
      super(props);

      this.refNuConfirm = React.createRef();
    }
    //------------------
    //---------------------------------
    componentDidMount() {
      //--limpiamos el array de prueba
      this.setState({data:[]});
      this.setState({options:[] })
      // Get the userId param from the URL.
      let idd = this.props.params.id;
      let ope = this.props.params.ope;
      
      console.log("idd*/}" + idd);
      console.log("ope*/}" + ope);
      let fecha_now = this.fecha_now()

      this.setState({ form:{...this.state.form, 
                            idd: idd, 
                            ope:ope,
                            fecha_ini: fecha_now,
                            hora_ini:'00:00',
                            fecha_fin: fecha_now,
                            hora_fin:'23:00',
                          }}); 
      if(ope==='e' || ope==='x'){
        this.cargar_form(idd, ope);
      }
      
      
    }
    //-------------------------------
    fecha_now=()=>{
      const date = moment();
      const dateNow = date.format('YYYY-MM-DD');
      return dateNow
    }
    //----------------especial, actualiza valores del form -------------------------------
    handleChangeForm = (e) => {
      //requerimos la prop name='?' en cada control
      
      //--- esto lo hacemos porque en vez de utilizar valores true, false
      //--- tenemos que utilizar 1, 0
      if(e.target.type==="checkbox"){

        let res = e.target.checked? 1:0;        
        this.setState({
          form:{
            ...this.state.form,
            [e.target.name]: res,
          }
        })
      }else{
        this.setState({
          form: {
            ...this.state.form,
            [e.target.name]: e.target.value,
          },
        });
      }
    };
 
    
    //-----------------------------------------
    cargar_form = (idd, ope) => {      
  
      let param = { 
        idd: idd,
        ope:'f'
      }
      console.log(param);
      axios2.post( "examend_store", param)
      .then(res => {
        
          if( res.data!==''){ 
              //añadimos el id y ope
              this.setState({
                form: {  ...res.data, 
                  idd: idd,  
                  ope: ope,
                },
              });
              
          }else{
            toast.error("Registro no encontrado", {
              position: toast.POSITION.TOP_RIGHT
            });
          }
  
      }).catch(error => {
          alert("---- Existio un error ---");
          console.log(error);
      });
    };
    //-------------
    handleSubmit = event => {
      event.preventDefault();
      this.cargar_form();
    }
    /****************** LIST *************************** */
    
    handleDeleteListFile=(item)=>{
      console.log("handleDeleteListFile")
      console.log(item)

    }
    /**************ADD ROW***************************** */
    add_row = ( miObj )=>{
      //eliminamos el row, falta hacer
      let valorNuevo= {...miObj };
      //valorNuevo.id=this.state.data.length+1;
      //valorNuevo.id=this.state.data.length;
      
      let lista= this.state.tarea_file;
      lista.push(valorNuevo);

      //console.log(miObj)
      this.setState({ tarea_file: lista});
      //setRows([...rows, { name: '', age: '' }]);
    }
    delete_row = (i)=>{
      const arrayCopy = this.state.tarea_file;
      arrayCopy.splice(i, 1);

      this.setState({ tarea_file : arrayCopy });// asigna todo el objeto
    }
    /******************************************** */
    /******************************************** */
    //---buscamos los datos de un estudiante preinscrito
    buscarClick =(e)=>{
      console.log("buscarClick")
      e.preventDefault()

      console.log("buscar")
      this.setState({modalShow:true});
    }
    //-------------esto viene del filename ---------------
    //---- llega un array
    handleOK=(arrItems)=>{ 
      console.log("handleOK")
      console.log(arrItems);
      //console.log("cad="+cad)
      this.setState({ modalShow: false});
      //----------tenemos que asignar el array 
      //this.setState({ options: data });
      for ( let item of arrItems ) 
      {
        //item *= 2;
        console.log( item );
        //---agregamos al array
        let obj = {
          value: item.filename,
          label: item.nombre,
        }
        this.add_row(obj)
      }
      
    }

    handleCancel=()=>{ 
      this.setState({ modalShow: false});
    }
    /************************************************ */
    //-----------------------------------------------
    aceptar_click = (e) => {
      console.log("aceptar");
      e.preventDefault()

      this.save();
    }
    //----------------------------
    save =() =>{    
      let materia = this.props.store.materia
      const user = this.props.store.user

        let param =  this.state.form
        param.id_mate = materia.id_mate
        param.id_peri = user.id_peri
        param.filename = this.state.options.toString()

        console.log(param)
        
        this.setState({ isloaging:true })
        axios2.post("examend_store", param)
        .then(res => {

            this.setState({ isloaging:false })
            if(res.data.exito === 1){ 
                toast.success(res.data.men);
                //--- tenemos que redireccionar
                this.props.navigate('/examend_list');
            }else{
                toast.error(res.data.men);
            }
    
        }).catch(error => {
            alert("---- Existio un error ---");
            console.log(error);
            
        });
      
    }
    handleClickListBtn=()=>{
      console.log("handleClickListBtn")
    }
    //------------------------------
    render() {
      return (
        <div>
          <ToastContainer />
          <div className="content">
            <h3>Examen</h3>

            <form id="form" method="post" >
              {
                JSON.stringify(this.state.form )
              }
              ----
              {
                JSON.stringify(this.state.tarea_file)
              }

              {/*  =====================================
                    FORM
                  ======================================*/}
              <div className="row">
                <div className="col-md-12">

                  <div className="row" >

                    <div className="col-md-2">
                      <label className="control-label" for="id_tarea">ID</label>
                    </div>

                    <div className="col-md-4">
                      <div className="form-inline">
                        <input
                          type='text'
                          name="idd"
                          className="form-control input-sm"
                          disabled={true}
                          value={this.state.form.idd}
                          onChange={this.handleChangeForm}
                        />
                      </div>
                    </div>

                  </div>


                  <br />


              

                  <br />
                  <div className="row">
                    <div className="col-md-2">
                      <label className="control-label" for="titulo">Título:</label>
                    </div>
                    <div className="col-md-6">

                      <NuInput
                        className='form-control input-sm'
                        type='text'
                        name='titulo'
                        value={this.state.form.titulo}
                        onChange={this.handleChangeForm}
                        classOK=''
                        classError='is-invalid'
                        //inputStyle={{}}
                        valtipo='string2'
                      />
                    </div>

                  </div>

                  <br />
                  <div className="row">
                    <div className="col-md-2">
                      <label className="control-label" for="descrip">Descripción:</label>
                    </div>
                    <div className="col-md-6">

                      <textarea
                        className="form-control"
                        
                        rows="3" 
                        name="descrip"
                        value={this.state.form.descrip}
                        onChange={this.handleChangeForm}></textarea>
                    </div>
                  </div>



                  <br />
                  <div className="row">
                    <div className="col-md-2">
                      <label className="control-label" for="descrip">Archivo(s):</label>
                      <br/>
                      <button className="btn btn-default"
                        onClick={ (e)=> this.buscarClick(e) }  >
                        <i className="fa fa-plus"></i>
                        Subir archivo
                      </button>
                    </div>
                    <div className="col-md-6">
                      { this.state.form.filename }
                      <ListFile
                        name=''
                        options={this.state.tarea_file}
                        value={this.state.tarea_file_sel}
                        onDelete={this.handleDeleteListFile}
                      />
                      
                      {/*--------------- */}
                    </div>
                    
                    </div>
                    <br/>



                      <div className="row">
                        <div className="col-md-12">
                          <p className="top_title2">
                            Fechas
                          </p>

                          <div className="multi-collapse collapse show" id="multiCollapseExample1" >
                            {/*   */}
                            <div className="form-group row ">
                              <div className="col-md-3 text-right">
                                <label className="d-inline word-break " for="id_name">
                                  Fecha inicio:
                                </label>
                              </div>
                              <div className="col-md-3 form-inline ">
                                <input type="date"
                                  className="form-control input-sm"
                                  name="fecha_ini"
                                  value={this.state.form.fecha_ini}
                                  onChange={this.handleChangeForm}
                                  required={true}
                                />
                              </div>
                              <div className="col-md-2">
                                Hora:
                              </div>
                              <div className="col-md-3">
                              
                                <input type="time"
                                  name="hora_ini"
                                  className="form-control input-sm"
                                  placeholder=""
                                  value={this.state.form.hora_ini}
                                  onChange={this.handleChangeForm}
                                />
                              </div>
                            </div>
                            {/*   */}
                            {/*   */}
                            <div className="form-group row ">
                              <div className="col-md-3 text-right">
                                <label className="d-inline word-break " for="id_name">
                                  Fecha de entrega:
                                </label>
                              </div>
                              <div className="col-md-3 form-inline ">
                                <input type="date"
                                  name="fecha_fin"
                                  className="form-control input-sm"
                                  value={this.state.form.fecha_fin}
                                  onChange={this.handleChangeForm}
                                  required={true}
                                />

                                
                              </div>
                              <div className="col-md-2">
                                Hora:
                              </div>
                              <div className="col-md-3">
                                <input type="time"
                                  name="hora_fin"
                                  className="form-control input-sm"
                                  placeholder=""
                                  value={this.state.form.hora_fin}
                                  onChange={this.handleChangeForm}
                                />
                              </div>
                            </div>
                            {/*   */}

                          </div>
                        </div>

                      </div>
                      <br/>
                      {/*<!-- -->*/}
                        <NuLoading text="Cargando...." show= { this.state.isloaging }/>
                      {/*<!-- -->*/}
                      <div className="col-md-12 text-center p-2" style={{ backgroundColor: '#ccc' }}>
                        <Button className="btn btn-primary st-btn" 
                                onClick={(e)=> this.aceptar_click(e) }>
                          <img src="assets/img/peq_ok.png" alt="" />&nbsp;Guardar. 
                        </Button>
                      </div>

                  </div>




                  {/*   */}
                  <div className="clearfix"></div>
                  {/*   */}
                  <div id="divres" className="form-group ">.</div>
                  {/*   */}


                </div>
            </form>




            {/*  Fin Contenido*/}
            {/*   /.content */}

          </div>

          <NuConfirm ref={this.refNuConfirm} />

          <NuFileUploadModal modalShow={ this.state.modalShow } 
            titulo="Entrada" 
            handleOK={ this.handleOK } 
            handleCancel={ this.handleCancel } 
            
            />
        </div>
      );
    }
  }
    
  //------------para que soporte la funcionalidad de parametros
  export default withRouterJim(Examend);